export default __webpack_public_path__ + "static/soundWaves2-6c2ad21e33419855cef14e113f0b919c.png";